import script from "./ClaimFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClaimFilters.vue?vue&type=script&setup=true&lang=ts"

import "./ClaimFilters.vue?vue&type=style&index=0&id=69d5f2b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d5f2b0"]])

export default __exports__